import React, { useState } from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  Avatar,
  Button,
  TextField,
  useMediaQuery,
  Paper,
  Divider
} from '@mui/material';
import {
  Email,
  Phone,
  LocationOn,
  CheckCircleOutline,
  Send as SendIcon,
  AccessTime
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import { fadeInRight, getTheme } from '../../theme/theme';
import { useNavigate } from 'react-router-dom';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import heroImage from '../../assets/images/saas_analytics_insights_unveiled_cover.jpg';

// Animation variants
const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

// const getTheme = (mode) => ({
//   palette: {
//     mode,
//     primary: {
//       main: mode === 'dark' ? '#6a1bff' : '#5e00ff'
//     },
//     secondary: {
//       main: mode === 'dark' ? '#00e5ff' : '#00b4cc'
//     },
//     background: {
//       default: mode === 'dark' ? '#121212' : '#f5f7ff',
//       paper: mode === 'dark' ? '#1a1a1a' : '#ffffff'
//     },
//     text: {
//       primary: mode === 'dark' ? '#ffffff' : '#000000',
//       secondary: mode === 'dark' ? '#b0b0b0' : '#555555'
//     },
//     success: {
//       main: '#4caf50'
//     }
//   },
//   shadows: Array(25).fill('none')
// });



const HeroSection = ({ theme }) => (
  <>
    <Box
      component="section"
      sx={{
        pt: { xs: 10, md: 16 },
        pb: { xs: 10, md: 14 },
        position: 'relative',
        overflow: 'hidden',
        // background: theme.palette.mode === 'dark'
        //   ? 'linear-gradient(135deg, rgba(10, 10, 26, 0.9) 0%, rgba(26, 26, 46, 0.9) 100%)'
        //   : 'linear-gradient(135deg, rgba(245, 247, 255, 0.9) 0%, rgba(230, 235, 255, 0.9) 100%)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          // background: theme.palette.mode === 'dark'
          //   ? 'radial-gradient(circle at 20% 50%, rgba(106, 27, 255, 0.15) 0%, transparent 60%)'
          //   : 'radial-gradient(circle at 20% 50%, rgba(106, 27, 255, 0.08) 0%, transparent 60%)',
          zIndex: 1
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          right: 0,
          width: '70%',
          height: '70%',
          // background: theme.palette.mode === 'dark'
          //   ? 'radial-gradient(circle at 80% 80%, rgba(0, 229, 255, 0.1) 0%, transparent 50%)'
          //   : 'radial-gradient(circle at 80% 80%, rgba(0, 229, 255, 0.05) 0%, transparent 50%)',
          zIndex: 1
        }
      }}
    >
      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
        {/* <Grid container spacing={{ xs: 1, md: 1 }} alignItems="center" justifyContent="space-between">
          <Grid item xs={12} md={6} lg={5}> */}
            <motion.div
              initial="hidden"
              animate="visible"
              variants={fadeInRight}
            >
              <Box sx={{ position: 'relative' }}>
                <Typography
                  // variant="overline"
                  sx={{
                    display: 'inline-block',
                    color: 'secondary.main',
                    fontWeight: 700,
                    letterSpacing: 1.8,
                    mb: 2,
                    position: 'relative',
                    pl: 1,
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      left: -10,
                      top: '50%',
                      width: 30,
                      height: 2,
                      backgroundColor: theme.palette.secondary.main,
                      transform: 'translateY(-50%)'
                    }
                  }}
                >
                  GET IN TOUCH
                </Typography>
              </Box>

              <Typography
                variant="h1"
                component="h1"
                gutterBottom
                sx={{
                  fontWeight: 800,
                  mb: { xs: 3, md: 4 },
                  background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text', // For Firefox
                  textFillColor: 'transparent', // For Firefox
                  fontSize: { xs: '2.75rem', sm: '3.25rem', md: '3.75rem', lg: '4.25rem' },
                  lineHeight: 1.1
                }}
              >
                Let's Build Something Amazing Together
              </Typography>
              <Typography
                variant="h5"
                component="p"
                color="text.secondary"
                paragraph
                sx={{
                  mb: 5,
                  maxWidth: '90%',
                  fontSize: { xs: '1.1rem', md: '1.25rem' },
                  lineHeight: 1.6,
                  fontWeight: 400
                }}
              >
                Have a project in mind or want to learn more about our services? Contact us today and our team will get back to you within 24 hours.
              </Typography>

              {/* <Box sx={{
                display: 'flex',
                gap: 3,
                flexWrap: { xs: 'wrap', sm: 'nowrap' }
              }}>
                <Button
                  variant="contained"
                  size="large"
                  href="#service-categories"
                  sx={{
                    px: { xs: 3, md: 5 },
                    py: 2,
                    fontWeight: 600,
                    background: theme.palette.gradients.primary || `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                    borderRadius: '50px',
                    '&:hover': {
                      transform: 'translateY(-3px)',
                      boxShadow: `0 8px 25px ${theme.palette.primary.main}40`
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  About Us
                </Button>

                <Button
                  variant="outlined"
                  size="large"
                  href="/contact"
                  sx={{
                    px: { xs: 3, md: 5 },
                    py: 2,
                    fontWeight: 600,
                    borderWidth: 2,
                    borderRadius: '50px',
                    borderColor: theme.palette.primary.main,
                    '&:hover': {
                      borderWidth: 2,
                      borderColor: theme.palette.primary.main,
                      transform: 'translateY(-3px)',
                      boxShadow: `0 8px 25px ${theme.palette.primary.main}20`
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  Contact Us
                </Button>
              </Box> */}
            </motion.div>
          {/* </Grid> */}

          {/* <Grid item xs={12} md={6} lg={6}>
            <motion.div
              initial={{ opacity: 0, y: 60, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
              whileHover={{ scale: 1.03 }}
            >
              <Box
                sx={{
                  position: 'relative',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: { xs: -15, md: -25 },
                    left: { xs: -15, md: -25 },
                    width: { xs: 150, md: 200 },
                    height: { xs: 150, md: 200 },
                    borderRadius: '50%',
                    background: `linear-gradient(45deg, ${theme.palette.primary.main}20, ${theme.palette.secondary.main}20)`,
                    zIndex: -1
                  },
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: { xs: -20, md: -30 },
                    right: { xs: -20, md: -30 },
                    width: { xs: 180, md: 250 },
                    height: { xs: 180, md: 250 },
                    borderRadius: '50%',
                    background: `linear-gradient(45deg, ${theme.palette.secondary.main}20, ${theme.palette.primary.main}20)`,
                    zIndex: -1
                  }
                }}
              >
                <Box
                  component="img"
                  src={heroImage}
                  alt="Digital Services"
                  sx={{
                    width: '964px',
                    height: '412px',
                    maxWidth: '964px',
                    maxHeight: '412px',
                    borderRadius: { xs: 3, md: 4 },
                    boxShadow: `0 25px 50px ${theme.palette.mode === 'dark' ? '#00000070' : '#6a1bff30'}`,
                    border: `1px solid ${theme.palette.mode === 'dark' ? '#ffffff15' : '#6a1bff15'}`,
                    transform: 'perspective(1500px) rotateY(-8deg)',
                    transition: 'all 0.4s ease',
                    filter: theme.palette.mode === 'dark' ? 'brightness(0.9)' : 'none',
                    '&:hover': {
                      transform: 'perspective(1500px) rotateY(-5deg) scale(1.02)',
                      boxShadow: `0 30px 60px ${theme.palette.mode === 'dark' ? '#00000080' : '#6a1bff40'}`,
                    }
                  }}
                />
              </Box>
            </motion.div>
          </Grid> */}
        {/* </Grid> */}
      </Container>
    </Box>

  </>
);


const SectionHeader = ({ overline, title, subtitle }) => (
  <Box sx={{ textAlign: 'center', mb: 8 }}>
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={fadeInUp}
    >
      <Typography
        variant="overline"
        sx={{
          display: 'block',
          color: 'secondary.main',
          fontWeight: 600,
          letterSpacing: 1.5,
          mb: 2,
        }}
      >
        {overline}
      </Typography>
      <Typography variant="h2" component="h2" gutterBottom sx={{
        fontWeight: 700,
        backgroundImage: 'linear-gradient(90deg, #6a1bff, #00e5ff)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        textFillColor: 'transparent',
      }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="h5"
          color="text.secondary"
          sx={{ maxWidth: 700, mx: 'auto' }}
        >
          {subtitle}
        </Typography>
      )}
    </motion.div>
  </Box>
);


const contactMethods = [
  {
    icon: <Email fontSize="large" />,
    title: 'Email Us',
    details: 'sales@soranova.in',
    action: 'mailto:sales@soranova.in',
    description: "Have a project in mind? Reach out to us and let's discuss."
  },
  {
    icon: <Phone fontSize="large" />,
    title: 'Call Us',
    details: '+91 8668507381 / +91 8408070640',
    action: 'tel:+15551234567',
    description: "Ready to team up? Excited to explore opportunities together."
  },
  {
    icon: <LocationOn fontSize="large" />,
    title: 'Visit Us',
    details: '4th Floor, Bizness square Junction, Opp. Hitex Road, Jubilee Enclave, HITEC City, Madhapur, Hyderabad, Telangana 500084',
    action: 'https://maps.google.com',
  },
];


const ValuesSection = () => {
  // Add hover state tracking for enhanced interactions
  const [hoveredValue, setHoveredValue] = React.useState(null);

  return (
    <Box id="values" sx={{
      py: { xs: 1, md: 0 },
      marginTop:0,
      // bgcolor: 'background.paper',
      position: 'relative',
      overflow: 'hidden', // Prevent any decorative elements from causing overflow
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '1px',
        // background: 'linear-gradient(90deg, transparent, rgba(106, 27, 255, 0.2), transparent)',
      },
      // Add decorative background elements
      '&::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        right: '-5%',
        width: '500px',
        height: '500px',
        borderRadius: '50%',
        //   background: 'radial-gradient(circle, rgba(106, 27, 255, 0.05) 0%, rgba(0, 229, 255, 0.02) 60%, transparent 70%)',
        zIndex: 0,
        transform: 'translateY(-50%)',
      }
    }}>
      {/* Add floating decorative elements */}
      <Box sx={{
        position: 'absolute',
        top: '15%',
        left: '-2%',
        width: '300px',
        height: '300px',
        //  background: 'radial-gradient(circle, rgba(0, 229, 255, 0.04) 0%, rgba(106, 27, 255, 0.02) 60%, transparent 70%)',
        zIndex: 0,
      }} />

      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
        {/* <SectionHeader
          overline="OUR CULTURE"
          title="Core Values"
          subtitle="The principles that guide everything we do"
        /> */}

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          variants={staggerContainer}
        >
          <Box sx={{
            py: { xs: 6, md: 10 },
          }}>
            <Box sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(3, 1fr)',
                md: 'repeat(3, 1fr)'
              },
              gap: { xs: 4, md: 5 },
            }}>
              {contactMethods.map((value, index) => (
                <motion.div
                  key={index}
                  whileHover={{
                    scale: 1.03,
                    transition: { duration: 0.3 }
                  }}
                  onHoverStart={() => setHoveredValue(index)}
                  onHoverEnd={() => setHoveredValue(null)}
                >
                  <Card sx={{
                    height: '100%',
                    p: 4,
                    textAlign: 'center',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    borderRadius: '50',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: hoveredValue === index ? '0 15px 30px rgba(106, 27, 255, 0.15)' : '0 6px 15px rgba(106, 27, 255, 0.08)',
                    background: hoveredValue === index ?
                      'linear-gradient(135deg, rgba(106, 27, 255, 0.03) 0%, rgba(0, 229, 255, 0.03) 100%)' :
                      'none',
                    borderColor: 'transparent',
                    borderWidth: 2,
                    borderStyle: 'solid',
                    borderImage: hoveredValue === index ?
                      'linear-gradient(135deg, rgba(106, 27, 255, 0.3), rgba(0, 229, 255, 0.3)) 1' :
                      'none',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      height: '4px',
                      background: 'linear-gradient(90deg, #6a1bff, #00e5ff)',
                      transform: hoveredValue === index ? 'scaleX(1)' : 'scaleX(0)',
                      transformOrigin: 'center',
                      transition: 'transform 0.4s ease',
                      borderTopLeftRadius: '16px',
                      borderTopRightRadius: '16px',
                    }
                  }}>
                    <motion.div
                      animate={hoveredValue === index ? { y: -5 } : { y: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <Avatar
                        className="valueIcon"
                        sx={{
                          width: 90,
                          height: 90,
                          bgcolor: theme => hoveredValue === index ?
                            'rgba(106, 27, 255, 0.25)' :
                            theme.palette.mode === 'dark' ?
                              'rgba(106, 27, 255, 0.15)' :
                              'rgba(94, 0, 255, 0.08)',
                          color: hoveredValue === index ? '#fff' : 'primary.main',
                          mb: 4,
                          mx: 'auto',
                          transition: 'all 0.4s ease',
                          background: hoveredValue === index ?
                            'linear-gradient(135deg, #6a1bff, #00e5ff)' :
                            'inherit',
                          boxShadow: hoveredValue === index ?
                            '0 8px 20px rgba(106, 27, 255, 0.25)' :
                            'none',
                        }}
                      >
                        {value.icon}
                      </Avatar>

                      <Typography
                        variant="h5"
                        component="h3"
                        gutterBottom
                        sx={{
                          fontWeight: 700,
                          mb: 2,
                          fontSize: { xs: '1.3rem', md: '1.5rem' },
                          position: 'relative',
                          display: 'inline-block',
                          '&::after': {
                            content: '""',
                            position: 'absolute',
                            width: hoveredValue === index ? '100%' : '40%',
                            height: '2px',
                            background: 'linear-gradient(90deg, #6a1bff, #00e5ff)',
                            bottom: '-6px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            transition: 'width 0.3s ease',
                            borderRadius: '2px',
                          }
                        }}
                      >
                        {value.title}
                      </Typography>

                      <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{
                          fontSize: '1rem',
                          lineHeight: 1.7,
                          opacity: 0.9,
                          maxWidth: '90%',
                          mx: 'auto',
                        }}
                      >
                        {value.details}
                      </Typography>

                      <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={hoveredValue === index ?
                          { opacity: 1, y: 0 } :
                          { opacity: 0, y: 20 }
                        }
                        transition={{ duration: 0.3 }}
                      >
                        <Box sx={{
                          mt: 3,
                          pt: 2,
                          opacity: hoveredValue === index ? 1 : 0,
                          transition: 'opacity 0.3s ease',
                        }}>
                          <Typography
                            variant="body2"
                            sx={{
                              color: 'primary.main',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: 0.5,
                            }}
                          >
                            {value.description}
                            {/* Learn more
                            <Box 
                              component="span" 
                              sx={{ 
                                display: 'inline-flex',
                                transition: 'transform 0.2s ease',
                                transform: hoveredValue === index ? 'translateX(3px)' : 'none',
                              }}
                            >
                              →
                            </Box> */}
                          </Typography>
                        </Box>
                      </motion.div>
                    </motion.div>
                  </Card>
                </motion.div>
              ))}
            </Box>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};


export const Contact = ({ mode = 'light' }) => {
  const theme = getTheme(mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const navigate = useNavigate();
  const [particlesLoaded, setParticlesLoaded] = useState(false);

  const particlesInit = async (engine) => {
    await loadFull(engine);
  };

  const particlesLoaded$ = async (container) => {
    setParticlesLoaded(true);
  };


  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
  };


  return (
    <>
      <Box sx={{
        bgcolor: mode === 'light' ? 'background.default' : 'background.default',
        color: 'text.primary',
        position: 'relative',
        overflow: 'hidden',
        pb: 8
      }}>
        <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0 }}>
          <Particles
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded$}
            options={{
              fullScreen: { enable: false },
              background: {
                color: {
                  value: 'transparent',
                },
              },
              fpsLimit: 60,
              particles: {
                color: {
                  value: mode === 'light' ? '#6a1bff' : '#00e5ff',
                },
                links: {
                  color: mode === 'light' ? '#6a1bff' : '#00e5ff',
                  distance: 150,
                  enable: true,
                  opacity: 0.3,
                  width: 1,
                },
                collisions: {
                  enable: true,
                },
                move: {
                  direction: 'none',
                  enable: true,
                  outModes: {
                    default: 'bounce',
                  },
                  random: false,
                  speed: 0.5,
                  straight: false,
                },
                number: {
                  density: {
                    enable: true,
                    area: 800,
                  },
                  value: 40,
                },
                opacity: {
                  value: 0.3,
                },
                shape: {
                  type: 'circle',
                },
                size: {
                  value: { min: 1, max: 3 },
                },
              },
              detectRetina: true,
            }}
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              zIndex: 0
            }}
          />
        </Box>

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
          <HeroSection theme={theme} />
          <ValuesSection theme={theme} />

        </Container>
        <Box
          sx={{
            py: { xs: 6, md: 10 },
            background: theme.palette.mode === 'dark'
              ? 'linear-gradient(135deg, rgba(106, 27, 255, 0.1) 0%, rgba(0, 229, 255, 0.05) 100%)'
              : 'linear-gradient(135deg, rgba(135, 92, 210, 0.05) 0%, rgba(0, 229, 255, 0.1) 100%)',
            //minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Container maxWidth="xl">
            <Paper
              elevation={6}
              sx={{
                borderRadius: 4,
                overflow: 'hidden',
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
              }}
            >
              {/* Left Side - Information */}
              <Box
                sx={{
                  flex: { xs: '1 1 100%', md: '1 1 40%' },
                  p: { xs: 4, md: 6 },
                  background: theme.palette.mode === 'dark'
                    ? 'linear-gradient(135deg, #2A2D3E 0%, #1A1C28 100%)'
                    : 'linear-gradient(135deg, #6A1BFF 0%, #00C6FF 100%)',
                  color: '#fff',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                }}
              >
                <Box>
                  <Typography
                    variant="overline"
                    sx={{
                      display: 'block',
                      fontWeight: 600,
                      letterSpacing: 1.5,
                      mb: 2,
                      opacity: 0.9
                    }}
                  >
                    CONNECT WITH US
                  </Typography>

                  <Typography variant="h2" component="h2" gutterBottom sx={{ fontWeight: 700 }}>
                    Get In Touch
                  </Typography>

                  <Typography variant="body1" paragraph sx={{ opacity: 0.85, mb: 4 }}>
                    Have a question or want to discuss a project? Reach out to our team and we'll get back to you as soon as possible.
                  </Typography>

                  <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.2)' }} />

                  {/* Contact Information */}
                  <Box sx={{ mt: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <AccessTime size={22} style={{ marginRight: 12 }} />
                      <Typography variant="body1">
                        Mon-Fri: 9:00 AM - 5:00 PM
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              {/* Right Side - Form */}
              <Box
                sx={{
                  flex: { xs: '1 1 100%', md: '1 1 60%' },
                  p: { xs: 4, md: 6 },
                  background: theme.palette.background.paper,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {submitted ? (
                  <Card
                    elevation={0}
                    sx={{
                      p: 6,
                      textAlign: 'center',
                      background: 'transparent',
                      width: '100%',
                      maxWidth: 500
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 80,
                        height: 80,
                        bgcolor: theme.palette.success.main,
                        color: '#fff',
                        mb: 3,
                        mx: 'auto',
                      }}
                    >
                      <CheckCircleOutline size={40} />
                    </Avatar>
                    <Typography variant="h4" component="h3" gutterBottom>
                      Thank You!
                    </Typography>
                    <Typography variant="body1" color="text.secondary" paragraph>
                      Your message has been sent successfully. We'll get back to you within 24 hours.
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => setSubmitted(false)}
                      sx={{ mt: 3, px: 4, py: 1.5 }}
                    >
                      Send Another Message
                    </Button>
                  </Card>
                ) : (
                  <Box sx={{ width: '100%', maxWidth: 600 }}>
                    <Typography
                      variant="h4"
                      component="h3"
                      gutterBottom
                      sx={{ fontWeight: 600, mb: 4 }}
                    >
                      Send Us a Message
                    </Typography>

                    <form onSubmit={handleSubmit}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Your Name"
                            variant="outlined"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Email Address"
                            variant="outlined"
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Phone Number"
                            variant="outlined"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Subject"
                            variant="outlined"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <TextField
                            fullWidth
                            label="Message"
                            variant="outlined"
                            multiline
                            rows={6}
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            size="large"
                            fullWidth
                            endIcon={<SendIcon />}
                            sx={{
                              py: 1.5,
                              mt: 2,
                              background: theme.palette.mode === 'dark'
                                ? 'linear-gradient(90deg, #6A1BFF 0%, #00C6FF 100%)'
                                : 'linear-gradient(90deg, #6A1BFF 0%, #00C6FF 100%)',
                              '&:hover': {
                                background: theme.palette.mode === 'dark'
                                  ? 'linear-gradient(90deg, #5A0BEF 0%, #00B6EF 100%)'
                                  : 'linear-gradient(90deg, #5A0BEF 0%, #00B6EF 100%)',
                              }
                            }}
                          >
                            Send Message
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  </Box>
                )}
              </Box>
            </Paper>
          </Container>
        </Box>
        <Box sx={{ py: { xs: 0, md: 0 } }}>
          <Box
            component="iframe"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4009.2161593530973!2d78.37169202828117!3d17.454086117551412!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93d09ebaf951%3A0xd7c99e75ceef5330!2sHitex!5e0!3m2!1sen!2sin!4v1746731179796!5m2!1sen!2sin"
            width="100%"
            height="25vh"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            sx={{
              display: 'block',
            }}
          />
        </Box>
      </Box>
    </>
  );
};